import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const jqlBuilderWithAiEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "async-jql-builder-with-ai" */ './JQLBuilderWithAI.tsx').then(
				(module) => module.JQLBuilderWithAIEntryPoint,
			),
		{ entryFsSsrLiftImportToModule: false },
	),
	getPreloadProps: () => ({}),
});
